import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILoadingDots from 'UIComponents/loading/UILoadingDots';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Loading = () => /*#__PURE__*/_jsxs(UIFlex, {
  direction: "column",
  align: "center",
  gap: 18,
  className: "m-top-7 m-bottom-8",
  children: [/*#__PURE__*/_jsx(UIIllustration, {
    name: "robot-small",
    width: "12%"
  }), /*#__PURE__*/_jsx("b", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "messaging-insights.insights.loading"
    })
  }), /*#__PURE__*/_jsx(UILoadingDots, {
    className: "m-top-4 m-bottom-2"
  })]
});
export default Loading;